import { Group, Paper, Title } from '@mantine/core';
import { ErrorRouteComponent } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import classes from './page.module.css';

import { ActionsMenu, CommonError, FullMainHeight, TsrButtonLink } from '@ui';

export const ErrorPage: ErrorRouteComponent = ({ error, reset }) => {
  const { t } = useTranslation();

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Group justify="space-between">
            <Title order={2}>{t('accounts.list_page_title')}</Title>
            <Group>
              <TsrButtonLink to="/accounts/create">
                {t('accounts.add_account')}
              </TsrButtonLink>
              <ActionsMenu.Button disabled />
            </Group>
          </Group>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <CommonError
          description={t('common.error.pageError')}
          error={error}
          reset={reset}
        />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
};

export default ErrorPage;
